// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdminLayout_shell__WwkQV { display: flex; min-height: 100vh; background: var(--gray-50); width: 100vw; overflow: hidden; }

.AdminLayout_sidebar__W9jLG {
  width: 220px;
  min-width: 220px;
  background: var(--white);
  border-right: 1px solid var(--border);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  z-index: 100;
  transition: transform 0.25s ease;
  overflow: hidden;
}

.AdminLayout_sidebarTop__Xtqnh { padding: 1.25rem 1rem; }

.AdminLayout_brand__CiFdu {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding-bottom: 1.25rem;
  margin-bottom: 1.25rem;
  border-bottom: 1px solid var(--border);
}

.AdminLayout_brandMark__WA16q {
  width: 40px;
  height: auto;
  flex-shrink: 0;
}

.AdminLayout_brandText__5TQeQ { display: flex; flex-direction: column; }
.AdminLayout_brandName__CEVMU { font-size: 0.8rem; font-weight: 600; color: var(--gray-900); line-height: 1.2; }
.AdminLayout_brandSub__0kbAS { font-size: 0.68rem; color: var(--gray-500); }

.AdminLayout_nav__cwgLY { display: flex; flex-direction: column; gap: 0.75rem; }

.AdminLayout_navGroup__MpeiP { display: flex; flex-direction: column; gap: 2px; }

.AdminLayout_navGroupLabel__BJ1cm {
  padding: 0.25rem 0.75rem;
  color: var(--gray-500);
  font-size: 0.65rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.AdminLayout_navItem__q34ne {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  padding: 0.55rem 0.75rem;
  border-radius: var(--radius);
  font-size: 0.82rem;
  color: var(--gray-700);
  transition: background 0.12s, color 0.12s;
}

.AdminLayout_navItem__q34ne:hover { background: var(--gray-50); color: var(--gray-900); }
.AdminLayout_navItem__q34ne.AdminLayout_active__zcaLD { background: var(--green-light); color: var(--green); font-weight: 500; }
.AdminLayout_navIcon__iSqPc { font-size: 0.95rem; width: 18px; text-align: center; }

.AdminLayout_sidebarBottom__hNaFj {
  padding: 1rem;
  border-top: 1px solid var(--border);
}

.AdminLayout_adminInfo__hHwNV {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  margin-bottom: 0.75rem;
}

.AdminLayout_adminAvatar__cWm\\+n {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: var(--green-light);
  color: var(--green);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  font-weight: 600;
  flex-shrink: 0;
}

.AdminLayout_adminMeta__dUxRK { display: flex; flex-direction: column; overflow: hidden; }
.AdminLayout_adminName__LeX1W { font-size: 0.78rem; font-weight: 500; color: var(--gray-900); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.AdminLayout_adminRole__CGyk6 { font-size: 0.68rem; color: var(--gray-500); }

.AdminLayout_logoutBtn__-t3xR {
  width: 100%;
  padding: 0.5rem;
  background: transparent;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  color: var(--gray-700);
  font-size: 0.78rem;
  transition: background 0.12s, color 0.12s;
}

.AdminLayout_logoutBtn__-t3xR:hover { background: var(--red-light); color: var(--red); border-color: rgba(192,57,43,0.2); }

/* Main content */
.AdminLayout_main__RPHpc { flex: 1 1; display: flex; flex-direction: column; overflow: hidden; margin-left: 220px; }

.AdminLayout_topbar__jMlBg {
  height: 48px;
  background: var(--white);
  border-bottom: 1px solid var(--border);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.25rem;
  display: none;
}

.AdminLayout_topbarRight__12zZ1 { display: flex; align-items: center; gap: 1rem; }
.AdminLayout_topbarUser__H4CqS { font-size: 0.8rem; color: var(--gray-700); }

.AdminLayout_menuBtn__jfmKt {
  display: flex;
  flex-direction: column;
  gap: 4px;
  background: none;
  border: none;
  padding: 4px;
  cursor: pointer;
}

.AdminLayout_menuBtn__jfmKt span {
  display: block;
  width: 20px;
  height: 2px;
  background: var(--gray-700);
  border-radius: 1px;
}

.AdminLayout_content__4b94f { flex: 1 1; padding: 1.5rem; overflow-y: auto; overflow-x: hidden; width: 100%; }

.AdminLayout_overlay__sxErN {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.4);
  z-index: 99;
}

@media (max-width: 768px) {
  .AdminLayout_sidebar__W9jLG {
    position: fixed;
    left: 0; top: 0; bottom: 0;
    transform: translateX(-100%);
    z-index: 200;
  }
  .AdminLayout_sidebar__W9jLG.AdminLayout_open__\\+rHfs { transform: translateX(0); }
  .AdminLayout_topbar__jMlBg { display: flex; }
  .AdminLayout_main__RPHpc { margin-left: 0; }
  .AdminLayout_content__4b94f { padding: 1rem; }
}

/* Logout Confirmation Modal */
.AdminLayout_modalOverlay__DkE8- {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 300;
}

.AdminLayout_modal__vU8St {
  background: var(--white);
  border-radius: var(--radius);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  max-width: 400px;
  width: 90%;
  overflow: hidden;
  animation: AdminLayout_slideUp__nPPoo 0.2s ease-out;
}

@keyframes AdminLayout_slideUp__nPPoo {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.AdminLayout_modalHeader__L1gfe {
  padding: 1.25rem;
  border-bottom: 1px solid var(--border);
}

.AdminLayout_modalTitle__JbvDn {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: var(--gray-900);
}

.AdminLayout_modalBody__MNBak {
  padding: 1.25rem;
  color: var(--gray-700);
  font-size: 0.9rem;
  line-height: 1.5;
}

.AdminLayout_modalBody__MNBak p {
  margin: 0;
}

.AdminLayout_modalFooter__J\\+dxA {
  padding: 1rem 1.25rem;
  border-top: 1px solid var(--border);
  display: flex;
  gap: 0.75rem;
  justify-content: flex-end;
}

.AdminLayout_modalBtnCancel__CukuZ {
  padding: 0.5rem 1rem;
  background: transparent;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  color: var(--gray-700);
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.12s, color 0.12s;
}

.AdminLayout_modalBtnCancel__CukuZ:hover {
  background: var(--gray-50);
  color: var(--gray-900);
}

.AdminLayout_modalBtnConfirm__VjATY {
  padding: 0.5rem 1rem;
  background: var(--red);
  border: 1px solid var(--red);
  border-radius: var(--radius);
  color: white;
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.12s, box-shadow 0.12s;
}

.AdminLayout_modalBtnConfirm__VjATY:hover {
  background: var(--red-dark);
  box-shadow: 0 2px 8px rgba(192, 57, 43, 0.2);
}

.AdminLayout_modalBtnConfirm__VjATY:active {
  transform: scale(0.98);
}

/* Loading Indicator */
.AdminLayout_loadingOverlay__iJPSa {
  position: fixed;
  inset: 0;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 250;
  animation: AdminLayout_fadeIn__ABoW1 0.15s ease-in;
}

@keyframes AdminLayout_fadeIn__ABoW1 {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.AdminLayout_loadingSpinner__\\+eC9B {
  width: 50px;
  height: 50px;
  border: 3px solid var(--gray-200);
  border-top: 3px solid var(--green);
  border-radius: 50%;
  animation: AdminLayout_spin__vQELx 0.8s linear infinite;
}

@keyframes AdminLayout_spin__vQELx {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/AdminLayout.module.css"],"names":[],"mappings":"AAAA,4BAAS,aAAa,EAAE,iBAAiB,EAAE,0BAA0B,EAAE,YAAY,EAAE,gBAAgB,EAAE;;AAEvG;EACE,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;EACb,YAAY;EACZ,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA,iCAAc,qBAAqB,EAAE;;AAErC;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,gCAAa,aAAa,EAAE,sBAAsB,EAAE;AACpD,gCAAa,iBAAiB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,gBAAgB,EAAE;AAC5F,+BAAY,kBAAkB,EAAE,sBAAsB,EAAE;;AAExD,0BAAO,aAAa,EAAE,sBAAsB,EAAE,YAAY,EAAE;;AAE5D,+BAAY,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;;AAE7D;EACE,wBAAwB;EACxB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,4BAA4B;EAC5B,kBAAkB;EAClB,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA,oCAAiB,0BAA0B,EAAE,sBAAsB,EAAE;AACrE,wDAAkB,8BAA8B,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;AACzF,8BAAW,kBAAkB,EAAE,WAAW,EAAE,kBAAkB,EAAE;;AAEhE;EACE,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,gCAAa,aAAa,EAAE,sBAAsB,EAAE,gBAAgB,EAAE;AACtE,gCAAa,kBAAkB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;AAC3I,gCAAa,kBAAkB,EAAE,sBAAsB,EAAE;;AAEzD;EACE,WAAW;EACX,eAAe;EACf,uBAAuB;EACvB,+BAA+B;EAC/B,4BAA4B;EAC5B,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA,sCAAmB,4BAA4B,EAAE,iBAAiB,EAAE,iCAAiC,EAAE;;AAEvG,iBAAiB;AACjB,2BAAQ,SAAO,EAAE,aAAa,EAAE,sBAAsB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;;AAE9F;EACE,YAAY;EACZ,wBAAwB;EACxB,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;AACf;;AAEA,kCAAe,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AAC9D,iCAAc,iBAAiB,EAAE,sBAAsB,EAAE;;AAEzD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA,8BAAW,SAAO,EAAE,eAAe,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,WAAW,EAAE;;AAExF;EACE,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE;IACE,eAAe;IACf,OAAO,EAAE,MAAM,EAAE,SAAS;IAC1B,4BAA4B;IAC5B,YAAY;EACd;EACA,uDAAgB,wBAAwB,EAAE;EAC1C,6BAAU,aAAa,EAAE;EACzB,2BAAQ,cAAc,EAAE;EACxB,8BAAW,aAAa,EAAE;AAC5B;;AAEA,8BAA8B;AAC9B;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,0CAA0C;EAC1C,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,mDAAgC;AAClC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;EACnC,aAAa;EACb,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,+BAA+B;EAC/B,4BAA4B;EAC5B,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,4BAA4B;EAC5B,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;AACxB;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,QAAQ;EACR,oCAAoC;EACpC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kDAA+B;AACjC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,kCAAkC;EAClC,kBAAkB;EAClB,uDAAoC;AACtC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".shell { display: flex; min-height: 100vh; background: var(--gray-50); width: 100vw; overflow: hidden; }\n\n.sidebar {\n  width: 220px;\n  min-width: 220px;\n  background: var(--white);\n  border-right: 1px solid var(--border);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  z-index: 100;\n  transition: transform 0.25s ease;\n  overflow: hidden;\n}\n\n.sidebarTop { padding: 1.25rem 1rem; }\n\n.brand {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding-bottom: 1.25rem;\n  margin-bottom: 1.25rem;\n  border-bottom: 1px solid var(--border);\n}\n\n.brandMark {\n  width: 40px;\n  height: auto;\n  flex-shrink: 0;\n}\n\n.brandText { display: flex; flex-direction: column; }\n.brandName { font-size: 0.8rem; font-weight: 600; color: var(--gray-900); line-height: 1.2; }\n.brandSub { font-size: 0.68rem; color: var(--gray-500); }\n\n.nav { display: flex; flex-direction: column; gap: 0.75rem; }\n\n.navGroup { display: flex; flex-direction: column; gap: 2px; }\n\n.navGroupLabel {\n  padding: 0.25rem 0.75rem;\n  color: var(--gray-500);\n  font-size: 0.65rem;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.navItem {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n  padding: 0.55rem 0.75rem;\n  border-radius: var(--radius);\n  font-size: 0.82rem;\n  color: var(--gray-700);\n  transition: background 0.12s, color 0.12s;\n}\n\n.navItem:hover { background: var(--gray-50); color: var(--gray-900); }\n.navItem.active { background: var(--green-light); color: var(--green); font-weight: 500; }\n.navIcon { font-size: 0.95rem; width: 18px; text-align: center; }\n\n.sidebarBottom {\n  padding: 1rem;\n  border-top: 1px solid var(--border);\n}\n\n.adminInfo {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n  margin-bottom: 0.75rem;\n}\n\n.adminAvatar {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  background: var(--green-light);\n  color: var(--green);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.8rem;\n  font-weight: 600;\n  flex-shrink: 0;\n}\n\n.adminMeta { display: flex; flex-direction: column; overflow: hidden; }\n.adminName { font-size: 0.78rem; font-weight: 500; color: var(--gray-900); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }\n.adminRole { font-size: 0.68rem; color: var(--gray-500); }\n\n.logoutBtn {\n  width: 100%;\n  padding: 0.5rem;\n  background: transparent;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  color: var(--gray-700);\n  font-size: 0.78rem;\n  transition: background 0.12s, color 0.12s;\n}\n\n.logoutBtn:hover { background: var(--red-light); color: var(--red); border-color: rgba(192,57,43,0.2); }\n\n/* Main content */\n.main { flex: 1; display: flex; flex-direction: column; overflow: hidden; margin-left: 220px; }\n\n.topbar {\n  height: 48px;\n  background: var(--white);\n  border-bottom: 1px solid var(--border);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 1.25rem;\n  display: none;\n}\n\n.topbarRight { display: flex; align-items: center; gap: 1rem; }\n.topbarUser { font-size: 0.8rem; color: var(--gray-700); }\n\n.menuBtn {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  background: none;\n  border: none;\n  padding: 4px;\n  cursor: pointer;\n}\n\n.menuBtn span {\n  display: block;\n  width: 20px;\n  height: 2px;\n  background: var(--gray-700);\n  border-radius: 1px;\n}\n\n.content { flex: 1; padding: 1.5rem; overflow-y: auto; overflow-x: hidden; width: 100%; }\n\n.overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,0.4);\n  z-index: 99;\n}\n\n@media (max-width: 768px) {\n  .sidebar {\n    position: fixed;\n    left: 0; top: 0; bottom: 0;\n    transform: translateX(-100%);\n    z-index: 200;\n  }\n  .sidebar.open { transform: translateX(0); }\n  .topbar { display: flex; }\n  .main { margin-left: 0; }\n  .content { padding: 1rem; }\n}\n\n/* Logout Confirmation Modal */\n.modalOverlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 300;\n}\n\n.modal {\n  background: var(--white);\n  border-radius: var(--radius);\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n  max-width: 400px;\n  width: 90%;\n  overflow: hidden;\n  animation: slideUp 0.2s ease-out;\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.modalHeader {\n  padding: 1.25rem;\n  border-bottom: 1px solid var(--border);\n}\n\n.modalTitle {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--gray-900);\n}\n\n.modalBody {\n  padding: 1.25rem;\n  color: var(--gray-700);\n  font-size: 0.9rem;\n  line-height: 1.5;\n}\n\n.modalBody p {\n  margin: 0;\n}\n\n.modalFooter {\n  padding: 1rem 1.25rem;\n  border-top: 1px solid var(--border);\n  display: flex;\n  gap: 0.75rem;\n  justify-content: flex-end;\n}\n\n.modalBtnCancel {\n  padding: 0.5rem 1rem;\n  background: transparent;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  color: var(--gray-700);\n  font-size: 0.85rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.12s, color 0.12s;\n}\n\n.modalBtnCancel:hover {\n  background: var(--gray-50);\n  color: var(--gray-900);\n}\n\n.modalBtnConfirm {\n  padding: 0.5rem 1rem;\n  background: var(--red);\n  border: 1px solid var(--red);\n  border-radius: var(--radius);\n  color: white;\n  font-size: 0.85rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.12s, box-shadow 0.12s;\n}\n\n.modalBtnConfirm:hover {\n  background: var(--red-dark);\n  box-shadow: 0 2px 8px rgba(192, 57, 43, 0.2);\n}\n\n.modalBtnConfirm:active {\n  transform: scale(0.98);\n}\n\n/* Loading Indicator */\n.loadingOverlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(255, 255, 255, 0.7);\n  backdrop-filter: blur(2px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 250;\n  animation: fadeIn 0.15s ease-in;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.loadingSpinner {\n  width: 50px;\n  height: 50px;\n  border: 3px solid var(--gray-200);\n  border-top: 3px solid var(--green);\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"shell": `AdminLayout_shell__WwkQV`,
	"sidebar": `AdminLayout_sidebar__W9jLG`,
	"sidebarTop": `AdminLayout_sidebarTop__Xtqnh`,
	"brand": `AdminLayout_brand__CiFdu`,
	"brandMark": `AdminLayout_brandMark__WA16q`,
	"brandText": `AdminLayout_brandText__5TQeQ`,
	"brandName": `AdminLayout_brandName__CEVMU`,
	"brandSub": `AdminLayout_brandSub__0kbAS`,
	"nav": `AdminLayout_nav__cwgLY`,
	"navGroup": `AdminLayout_navGroup__MpeiP`,
	"navGroupLabel": `AdminLayout_navGroupLabel__BJ1cm`,
	"navItem": `AdminLayout_navItem__q34ne`,
	"active": `AdminLayout_active__zcaLD`,
	"navIcon": `AdminLayout_navIcon__iSqPc`,
	"sidebarBottom": `AdminLayout_sidebarBottom__hNaFj`,
	"adminInfo": `AdminLayout_adminInfo__hHwNV`,
	"adminAvatar": `AdminLayout_adminAvatar__cWm+n`,
	"adminMeta": `AdminLayout_adminMeta__dUxRK`,
	"adminName": `AdminLayout_adminName__LeX1W`,
	"adminRole": `AdminLayout_adminRole__CGyk6`,
	"logoutBtn": `AdminLayout_logoutBtn__-t3xR`,
	"main": `AdminLayout_main__RPHpc`,
	"topbar": `AdminLayout_topbar__jMlBg`,
	"topbarRight": `AdminLayout_topbarRight__12zZ1`,
	"topbarUser": `AdminLayout_topbarUser__H4CqS`,
	"menuBtn": `AdminLayout_menuBtn__jfmKt`,
	"content": `AdminLayout_content__4b94f`,
	"overlay": `AdminLayout_overlay__sxErN`,
	"open": `AdminLayout_open__+rHfs`,
	"modalOverlay": `AdminLayout_modalOverlay__DkE8-`,
	"modal": `AdminLayout_modal__vU8St`,
	"slideUp": `AdminLayout_slideUp__nPPoo`,
	"modalHeader": `AdminLayout_modalHeader__L1gfe`,
	"modalTitle": `AdminLayout_modalTitle__JbvDn`,
	"modalBody": `AdminLayout_modalBody__MNBak`,
	"modalFooter": `AdminLayout_modalFooter__J+dxA`,
	"modalBtnCancel": `AdminLayout_modalBtnCancel__CukuZ`,
	"modalBtnConfirm": `AdminLayout_modalBtnConfirm__VjATY`,
	"loadingOverlay": `AdminLayout_loadingOverlay__iJPSa`,
	"fadeIn": `AdminLayout_fadeIn__ABoW1`,
	"loadingSpinner": `AdminLayout_loadingSpinner__+eC9B`,
	"spin": `AdminLayout_spin__vQELx`
};
export default ___CSS_LOADER_EXPORT___;
